var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-fade-transition',{attrs:{"hide-on-leave":"","leave-absolute":""}},[(_vm.loading)?_c('loader'):_c('div',{staticClass:"fill-height"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }